import { render, staticRenderFns } from "./FooterLp.vue?vue&type=template&id=67a6bbf4&"
import script from "./FooterLp.vue?vue&type=script&lang=js&"
export * from "./FooterLp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports